import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Scanner3dAccountModel} from '../scanner3dAccount.model';
import {Scanner3dConverter} from '../../../../common/api/entity/converter/scanner3d.converter';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Scanner3dAccountAgentConfigurationModel} from "../scanner3dAccountAgentConfiguration.model";

@Injectable({
    providedIn: 'root'
})
export class Scanner3dAccountAgentConfigurationConverter extends HttpModelConverter<Scanner3dAccountAgentConfigurationModel> {

    constructor() {
        super();
    }

    protected createInstance(): Scanner3dAccountAgentConfigurationModel {
        return new Scanner3dAccountAgentConfigurationModel();
    }

    protected enrichObject(result: Scanner3dAccountAgentConfigurationModel, src: Scanner3dAccountAgentConfigurationModel) {
    }
}
